// extracted by mini-css-extract-plugin
module.exports = {"container":"ProductLocationsList_container__zqqHY","location":"ProductLocationsList_location__AJ_h7"};